const ADSyncConstants = [
  'DELETE_AD_SYNC',
];

export default ADSyncConstants;
